import React from "react"
import { Chip, useTheme } from "@mui/material"

interface BrowserCardLabelProps {
  label: string
  labelBackgroundColor: string
  labelTextColor: string
}

export const BrowserCardLabel = ({ label, labelBackgroundColor, labelTextColor }: BrowserCardLabelProps) => {
  const { spacing } = useTheme()
  return <Chip label={label} size="small" sx={{
    fontSize: '10px',
    fontWeight: 500,
    backgroundColor: labelBackgroundColor,
    color: labelTextColor,
    '& .MuiChip-label': {
      p: spacing(1.5, 2)
    }
  }} />
}
